import Navbar from "../sections/web_core/Navbar";
import SecondHeroSection from "../sections/web_core/SecondHeroSection";
import IMAGE_1 from "../Assets/Courses/imgi_25_page-title.jpg";
import CoursesGrid from "../sections/web_core/CourseGrid";
import Footer from "../sections/web_core/Footer";
const Courses = () => {
  return (
    <div className="flex flex-col min-h-screen">

      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <SecondHeroSection
        title="Our Courses"
        subtitle="Explore our wide range of professional courses"
        bgImage={IMAGE_1}
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Courses" },
        ]}
      />

      {/* Courses Grid (already coded by you) */}
      <CoursesGrid 

      />
<Footer/>
    </div>
  );
};

export default Courses;
